import { useContext } from "react";
import { ArtistContext } from "../../contexts/artist";

export default () => useContext(ArtistContext);
